import { createGlobalResource } from './createGlobalResource';
import React, { useCallback } from 'react';

const { withGlobalResource, useGlobalResource, useUpdateGlobalResource } = createGlobalResource<string>();

export function useWithSelectedMenu() {
    return useCallback((children: React.ReactNode) => {
        return withGlobalResource(children);
    }, []);
}

export function useSelectedMenu() {
    const value = useGlobalResource();
    return value ?? 'Dashboard';
}

export function useSelectMenu() {
    const updater = useCallback((menu: string) => {
        return menu;
    }, []);
    return useUpdateGlobalResource(updater);
}
